import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			name: 'home',
			component: () => import(/* webpackChunkName: "Home" */ './views/Home.vue'),
		},
		{
			path: '/projects',
			name: 'projects',
			component: () => import(/* webpackChunkName: "projects" */ './views/Projects.vue'),
		},
		{
			path: '/contact',
			name: 'contact',
			component: () => import(/* webpackChunkName: "contact" */ './views/Contact.vue'),
		},
		{
			path: '/journey',
			name: 'journey',
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () => import(/* webpackChunkName: "Journey" */ './views/Journey.vue'),
		},
		{
			path: '/404',
			component: () => import(/* webpackChunkName: "Journey" */ './views/404.vue'),
		},
		{
			path: '*',
			redirect: '/404',
		},
	],
});
